export default "__VITE_ASSET__1641bfe8__"